<template>
  <div class="general-info">
    <label class="form__input">
      <span class="form__label">Is Active</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :isSmartInput="false"
        :smartInputStyle="{ 'padding-left': '20px' }"
        placeholder="Select Status"
        :options="activeOptions"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.clientDataModel.is_active"
        :max-height-list="450"
      />
    </label>
    <label class="form__input">
      <span class="form__label">Name</span>
      <div class="form__field-wrapper">
        <input type="text"
               class="form__field"
               :class="{'form__field_error': $parent.errorFields.name}"
               placeholder="Name"
               v-model="$parent.clientDataModel.name">
      </div>
      <span class="form__error-message" v-if="$parent.errorFields.name">{{ $parent.errorFields.name }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Email</span>
      <div class="form__field-wrapper">
        <input type="text"
               class="form__field"
               :class="{'form__field_error': $parent.errorFields.email}"
               placeholder="Email"
               v-model="$parent.clientDataModel.email">
      </div>
      <span class="form__error-message" v-if="$parent.errorFields.email">{{ $parent.errorFields.email }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Agency</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.agency}"
        placeholder="Select Agency"
        :options="agencies"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.clientDataModel.agency"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.agency">{{ $parent.errorFields.agency }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Guideline</span>
      <editor
        v-model="$parent.clientDataModel.guideline"
        :init="{
            verify_html: false,
            menubar: false,
            statusbar: false,
            plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
            toolbar: 'undo redo | formatselect | bold italic backcolor | link | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
            height: '300'
          }"
      ></editor>
    </label>
      <label class="form__input">
      <span class="form__label">Project End Date</span>
      <div class="form__field-wrapper">
        <base-date-picker-button
          :disabled="!isUserSuperAdmin"
          v-model="projectEndDateDisplay"
          :minDate="startDateMinDate"
          @change="changeProjEndDate"
          class="form__field datepicker"
          :class="{'form__field_err': $parent.errorFields.trial_end_date}"
        ></base-date-picker-button>
      </div>
      <span class="form__error-message" v-if="$parent.errorFields.trial_end_date">{{ $parent.errorFields.trial_end_date }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Scheduled Rank Report Start Date</span>
      <div class="form__field-wrapper">

        <base-date-picker-button
          :disabled="!isUserSuperAdmin"
          v-model="$parent.clientDataModel.scheduled_rank_report_start_date"
          :minDate="startDateMinDate"
          class="form__field datepicker"
          :class="{'form__field_err': $parent.errorFields.scheduled_rank_report_start_date}"

        ></base-date-picker-button>
      </div>
      <span class="form__error-message" v-if="$parent.errorFields.scheduled_rank_report_start_date">{{ $parent.errorFields.scheduled_rank_report_start_date }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Scheduled Rank Report Day Interval</span>
      <div class="form__field-wrapper">
        <base-select
            :disabled="!isUserSuperAdmin"
            :headerStyle="{ 'border-width': '2px', 'color': !isUserSuperAdmin && '#7a8894' }"
            alignLeft
            shiftLabelRight
            :smartInputStyle="{ 'padding': '0px' }"
            :selectStyle="{ height: '60px !important' }"
            :max-height-list="450"
            class="form__field day_interval_list"
            :class="{'form__field_err': $parent.errorFields.scheduled_rank_report_day_interval}"
            :options="dayIntervalOptions"
            :isSortAsc="true"
            borderLess
            v-model="$parent.clientDataModel.scheduled_rank_report_day_interval"
            placeholder="day interval"/>
      </div>
      <span class="form__error-message" v-if="$parent.errorFields.scheduled_rank_report_day_interval">{{ $parent.errorFields.scheduled_rank_report_day_interval }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Next Scheduled Report Date</span>
      <div class="form__field-wrapper">
        <input type="text"
               readonly
               v-model="nextScheduledReportDate"
               :style="{ 'color': '#7a8894'}"
               class="form__field">
      </div>
    </label>
    <label class="form__input">
      <span class="form__label">Automated HTTP Status Update</span>
      <div class="form__field-wrapper">
        <base-select
            :disabled="!(isUserSuperAdmin || isUserAgencyAdmin)"
            :headerStyle="{ 'border-width': '2px', 'color': !(isUserSuperAdmin || isUserAgencyAdmin) && '#7a8894' }"
            alignLeft
            shiftLabelRight
            :smartInputStyle="{ 'padding': '0px' }"
            :selectStyle="{ height: '60px !important' }"
            :max-height-list="450"
            class="form__field day_interval_list"
            :options="statusUpdateOptions"
            borderLess
            v-model="$parent.clientDataModel.automated_http_status_update"
            />
      </div>
      <span class="form__error-message" v-if="$parent.errorFields.scheduled_rank_report_day_interval">{{ $parent.errorFields.scheduled_rank_report_day_interval }}</span>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Editor from '@tinymce/tinymce-vue'
import moment from 'moment'
import _ from 'lodash'

const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]

const STATUS_UPDATE_OPTIONS = [
  {
    label: 'Enabled',
    value: 1
  },
  {
    label: 'Disabled',
    value: 0
  }
]
export default {
  name: 'GeneralInfo',
  components: {
    editor: Editor
  },
  data () {
    return {
      activeOptions: [...ACTIVE_OPTIONS],
      isSchedulerDirty: false,
      statusUpdateOptions: [...STATUS_UPDATE_OPTIONS]
    }
  },
  computed: {
    ...mapState('client', ['audienceKeys', 'agencies']),
    scheduledRankReportStartDateDisplay () {
      return this.$parent.clientDataModel.scheduled_rank_report_start_date
    },
    projectEndDateDisplay () {
      return moment(this.$parent.clientDataModel.trial_end_date).toDate()
    },
    startDateMinDate () {
      return moment().add(1, 'days').toDate()
    },
    dayIntervalOptions () {
      return _.range(366).map(num => ({ label: num || 'n/a', value: num }))
    },
    nextScheduledReportDate () {
      if (!this.isSchedulerDirty && this.$parent.clientDataModel.scheduled_rank_report_next_date) {
        return moment(this.$parent.clientDataModel.scheduled_rank_report_next_date).format('MMM DD, YYYY')
      }
      const isIntervalFalse = !this.$parent.clientDataModel.scheduled_rank_report_day_interval
      const isStartDateNone = this.$parent.clientDataModel.scheduled_rank_report_start_date === 'None'
      const isStartDateFalse = !this.$parent.clientDataModel.scheduled_rank_report_start_date
      if (isIntervalFalse || isStartDateNone || isStartDateFalse) {
        return null
      }
      let nextDate = moment(this.$parent.clientDataModel.scheduled_rank_report_start_date)
        .add(this.$parent.clientDataModel.scheduled_rank_report_day_interval, 'days')
      while (nextDate.diff(moment()) < 0) {
        nextDate = nextDate.add(this.$parent.clientDataModel.scheduled_rank_report_day_interval, 'days')
      }
      return nextDate.format('MMM DD, YYYY')
    },
    isUserSuperAdmin () {
      return this.userRoles.includes('admin')
    },
    isUserAgencyAdmin () {
      return this.userRoles.includes('agency_admin')
    }
  },
  methods: {
    changeProjEndDate (newVal) {
      if (moment(newVal).isValid()) {
        this.$parent.clientDataModel.trial_end_date = moment(newVal).format('YYYY-MM-DD')
      } else {
        this.$parent.clientDataModel.trial_end_date = null
      }
    }
  },
  watch: {
    '$parent.clientDataModel.scheduled_rank_report_start_date': function (v) {
      if (!v || v === 'clear') {
        this.$parent.clientDataModel.scheduled_rank_report_day_interval = null
      }
      this.isSchedulerDirty = true
    },
    '$parent.clientDataModel.scheduled_rank_report_day_interval': function (v) {
      if (!v) {
        this.$parent.clientDataModel.scheduled_rank_report_start_date = null
      }
      this.isSchedulerDirty = true
    },
    '$parent.clientDataModel.trial_end_date': function () {
      this.isSchedulerDirty = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .day_interval_list {
    padding: 0 !important;
  }
  .datepicker {
    padding-top: 10px !important;
    height: 100% !important;
    min-height: 40px;
  }
  .general-info {
    .form__field_error {
      &::v-deep .select__header-border {
        border-color: $rfx-red !important;
      }

      &::v-deep .select__selection,
      &::v-deep .select__placeholder {
        color: $rfx-red !important;
      }
    }
  }
</style>
